"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Heading = _interopRequireDefault(require("@components/Heading"));

var _Text = _interopRequireDefault(require("@components/Text"));

var _Image = _interopRequireDefault(require("@components/Images/Image"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _scss = require("@scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Card = /*#__PURE__*/(0, _react.memo)(function Card(_ref) {
  var _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'div' : _ref$component,
      type = _ref.type,
      ImageComponent = _ref.img,
      imgTop = _ref.imgTop,
      _ref$imgTopAlt = _ref.imgTopAlt,
      imgTopAlt = _ref$imgTopAlt === void 0 ? '' : _ref$imgTopAlt,
      preTitleComponent = _ref.preTitleComponent,
      title = _ref.title,
      titleHref = _ref.titleHref,
      _ref$titleComponent = _ref.titleComponent,
      titleComponent = _ref$titleComponent === void 0 ? 'h5' : _ref$titleComponent,
      text = _ref.text,
      _ref$textComponent = _ref.textComponent,
      textComponent = _ref$textComponent === void 0 ? 'p' : _ref$textComponent,
      children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onKeyDown = _ref.onKeyDown,
      className = _ref.className,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    title: '',
    text: '',
    imgWrapper: '',
    img: '',
    wrapper: '',
    body: ''
  } : _ref$classes;
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onKeyDown: onKeyDown,
    className: (0, _scss.cls)(_stylesModule["default"]['card'], _stylesModule["default"]["card-".concat(type)], classes['wrapper'], className)
  }, imgTop && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    src: imgTop,
    alt: imgTopAlt,
    className: classes.img
  })), !imgTop && ImageComponent ? ImageComponent : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['card-body'], classes['body'])
  }, preTitleComponent, title ? titleHref ? /*#__PURE__*/_react["default"].createElement("a", {
    href: titleHref,
    title: title
  }, /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
    component: titleComponent,
    className: (0, _scss.cls)(_stylesModule["default"]['card-title'], classes['title'])
  }, title)) : /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
    component: titleComponent,
    className: (0, _scss.cls)(_stylesModule["default"]['card-title'], classes['title'])
  }, title) : null, text ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    component: textComponent,
    className: (0, _scss.cls)(_stylesModule["default"]['card-text'], classes['text'])
  }, text) : null, children));
});
var _default = Card;
exports["default"] = _default;